// extracted by mini-css-extract-plugin
export default {"spinner":"tilWZ","loggedInStakeContainer":"VH6cS","emptyStakeText":"tY7gY"};